export default "__VITE_ASSET__OamfTpTk__"